import React from "react";
import './MenuFrontalSelector.scss'

const MenuFrontalSelector = ({ opciones = [], selected, setSelected ,maxWidth="100%",className}) => {
    return (
        <div className={`MenuFrontalSelector ${className}`} >
            {
                opciones.map((item) => {
                    return (
                        <>
                            {
                                selected == item ?
                                    <>
                                        <div className={`opcionMenu selected`} style={{maxWidth:maxWidth}}>{item}</div>
                                    </> :
                                    <>
                                        <div className={`opcionMenu unselected` } style={{maxWidth:maxWidth}} onClick={()=>{setSelected(item)}}>{item}</div>
                                    </>

                            }
                        </>
                    )
                })
            }
        </div>
    )
}
export default MenuFrontalSelector